import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Box,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Toolbar,
  Typography,
  Checkbox,
  Link,
  IconButton,
  TableHead,
  TableContainer,
  Paper,
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import EditIcon from '@material-ui/icons/EditOutlined';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@material-ui/core';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import { AiOutlineLine } from 'react-icons/ai';
import KenGridEditable from '../../../global_components/kenEditDataGrid/kenGridEditable';
import { RiCheckFill } from 'react-icons/ri';
import { RiFilterLine } from 'react-icons/ri';
import { HiOutlinePencilAlt, HiOutlineTrash } from 'react-icons/hi';
import { makeStyles } from '@material-ui/styles';
import BreadCrumb from '../../../Components/BreadCrumb';
import { useHistory, useLocation } from 'react-router-dom';
import routes from '../../../Utils/routes.json';
import KenSelect from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import KenCard from '../../../global_components/KenCard';
import KenGrid from '../../../global_components/KenGrid';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenPopover from '../../../Components/KenPopOver';
import {
  selectOptions,
  todayDropDown,
  intakeOptions,
  selectOptionsSection,
  courses,
  yearOptions,
  modeDropdown,
} from './data/data';
import KenInputField from '../../../global_components/KenInputField';
import { AiOutlineMinusSquare } from 'react-icons/ai';
import { AiOutlinePlusSquare } from 'react-icons/ai';
import ProgramFilter from './ProgramFilter';
import KenDialog from '../../../global_components/KenDialogBox';
import KenLoader from '../../../Components/KenLoader/index';
import FormControl from '@material-ui/core/FormControl';
import RadioGroup from '@material-ui/core/RadioGroup';
import './addActivity.css';
import {
  getAcademicFilter,
  getAcademicPlannerData,
  postAcademicPlanner,
  getMasterActivityWithTermData,
  getImportTermActivity,
  getFacultyAndFacilty,
  getCourseVersion,
} from '../../../Utils/apiServices';
import Reference from '../FullCalendar/Reference';

const arrayBreadCrumb = [
  { head: 'HOME', url: routes.home },
  {
    head: 'ADD TERM ACADEMIC PLANNER',
  },
];

const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },
  dateLabels: {
    lineHeight: '42px',
    marginRight: '10px',
    fontSize: '12px',
  },
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  noDataFound: {
    fontWeight: '600',
    fontSize: '14px',
  },
  filterButton: {
    marginRight: '10px',
  },
}));

const ActionCell = (row) => {
  return (
    <Box>
      <Button
        size="small"
        variant="contained"
        color="primary"
        className="add-program-button"
        style={{ borderRadius: 15 }}
        startIcon={<HiOutlinePencilAlt className="m-0" />}
      >
        Edit
      </Button>{' '}
      <Button
        size="small"
        variant="contained"
        color="primary"
        className="add-program-button"
        style={{ borderRadius: 15 }}
        startIcon={<HiOutlineTrash className="m-0" />}
      >
        Delete
      </Button>
    </Box>
  );
};

const columns = [
  {
    Header: 'ID',
    accessor: 'id',
    disableGlobalFilter: true,
  },
  {
    Header: 'activity',
    accessor: 'activity',
    disableGlobalFilter: true,
  },
  {
    Header: 'Subject',
    accessor: 'subject',
    disableGlobalFilter: true,
  },
  {
    Header: 'Faculty',
    accessor: 'faculty',
    disableGlobalFilter: true,
  },
  {
    Header: 'Start Date',
    accessor: 'start_date',
    disableGlobalFilter: true,
  },
  {
    Header: 'End Date',
    accessor: 'end_date',
    disableGlobalFilter: true,
  },
  {
    Header: 'Actions',
    accessor: 'actions',
    Cell: ActionCell,
  },
];

const masterHead = [
  {
    Header: 'Week No.',
    accessor: 'durationInWeeks',
    disableGlobalFilter: false,
  },
  {
    Header: 'Activity',
    accessor: 'activity',
    disableGlobalFilter: false,
  },
  {
    Header: 'Subject',
    accessor: 'subject',
    disableGlobalFilter: false,
  },
  {
    Header: 'Faculty',
    accessor: 'faculty',
    disableGlobalFilter: false,
  },
  {
    Header: 'Start Date',
    accessor: 'startDate',
    disableGlobalFilter: false,
  },
  {
    Header: 'End Date',
    accessor: 'endDate',
    disableGlobalFilter: false,
  },
];
const createData = (
  id,
  weekNo,
  activity,
  subject,
  faculty,
  startDate,
  endDate,
  saved
) => ({
  id,
  weekNo,
  activity,
  subject,
  faculty,
  startDate,
  endDate,
  saved,
});
const selectOptionsSubject = [
  { label: 'Lecture', value: 'Lecture' },
  { label: 'Exam', value: 'Exam' },
  { label: 'Lab', value: 'Lab' },
  { label: 'Tutorial', value: 'Tutorial' },
  { label: 'Practical', value: 'Term Break' },
  { label: 'Workshop', value: 'Workshop' },
  { label: 'Travel', value: 'Travel' },
  { label: 'Term Break', value: 'Term Break' },
  { label: 'Holiday', value: 'Holiday' },
  { label: 'Other', value: 'Other' },
];

const defaultValues = {
  programFrom: '',
  intakeFrom: '',
  courseFrom: '',
  startDateFrom: '',
  endDateFrom: '',
  programTO: '',
  intakeTO: '',
  courseTO: '',
  startDateTO: '',
  endDateTO: '',
};

const AddActivity = () => {
  const history = useHistory();
  const classes = useStyles();
  const location = useLocation();
  const [value, setValue] = React.useState('Online');
  const [startDay, setStartDay] = useState(todayDropDown[0].value);
  const [endDay, setEndDay] = useState(todayDropDown[0].value);
  const [term, setTerm] = useState();
  const [termDropdown, setTermDropdown] = useState([]);
  const [startDate, setStartDate] = useState('25-02-2022');
  const [endDate, setEndDate] = useState('25-02-2022');
  const [termStart, setTermStart] = useState('');
  const [termEnd, setTermEnd] = useState('');
  const [totalDay, setTotalDay] = useState('');
  const [totalHrWeek, setTotalHrWeek] = useState('');
  const [selectValue, setSelectValue] = useState(selectOptions[0].value);
  const [accordienCheck, setAccordienCheck] = useState(true);
  const [masterAccordian, setMasterAccordian] = useState(true);
  const [selectSectionValue, setSelectSectionValue] = useState(
    selectOptionsSection[0].value
  );
  const [selectValueSubject, setSelectValueSubject] = useState(
    selectOptionsSubject[0].value
  );
  const [formValues, setFormValues] = useState(defaultValues);
  const [loading, setLoading] = React.useState(false);
  const [cloneDialog, setCloneDialog] = useState(false);
  const [masterData, setMasterData] = useState([]);
  const [masterDialog, setMasterDialog] = useState(false);
  const [masterImportSuccess, setMasterImportSuccess] = useState(false);
  const [disableMaster, setDisableMaster] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEls, setAnchorEls] = useState(null);
  const [anchorElIgnore, setAnchorElIgnore] = useState(null);
  const [isFiltered, setIsFiltered] = useState(false);
  const [filters, setFilters] = useState({});
  const [programName, setProgramName] = useState(
    location?.state?.programName || sessionStorage.getItem('programName')
  );
  const [intake, setIntake] = useState(
    location?.state?.intake || sessionStorage.getItem('intake')
  );
  const [year, setYear] = useState(
    location?.state?.year || sessionStorage.getItem('year')
  );
  const [ignoreHoliday, setIgnoreHoliday] = useState(false);
  const [filterProgram, setFilterProgram] = useState(false);
  const [previous, setPrevious] = useState({});
  const [gradeInp, setGradeInp] = useState({});
  const [dataStream, setDataStream] = useState({});
  const [accordienSecondCheck, setAccordienSecondCheck] = useState(false);
  const [accordienThirdCheck, setAccordienThirdCheck] = useState(false);
  const [accordienFourthCheck, setAccordienFourthCheck] = useState(false);
  const [newActivity, setNewActivity] = useState(false);
  const [editIndex, setEditIndex] = useState();
  const [toMode, setToMode] = useState('Online');
  const [campusOptions, setCampusOptions] = React.useState([]);
  const [courseOptions, setCourseOptions] = React.useState([]);
  const ignoreOpen = Boolean(anchorElIgnore);
  const ignoreIds = ignoreOpen ? 'simple-popover' : undefined;
  const [nextApproved, setNextApproved] = useState(true);
  const [locationData, setLocationData] = useState();
  const [selectedAcademicProgram, setSelectedAcademicProgram] = useState();
  const [weekNo, setWeekNo] = useState();
  const [disableAddActivity, setDisableAddActivity] = useState(false);
  const [programID, setProgramID] = useState('');
  const [confirmDialogAddReference, setConfirmDialogAddReference] =
    useState(false);
  const [sessions, setSessions] = useState([]);
  const [facultyOptions, setFacultyOptions] = useState([]);
  const [sessionValue, setSessionValue] = useState('');
  const [subjects, setSubjects] = useState([]);
  const [selectSubjectValue, setSelectSubjectValue] = React.useState('');
  const [allSubjects, setAllSubjects] = useState([]);
  const [sections, setSections] = useState([]);
  const [facultyName, setFacultyName] = useState('');
  const [facultyNameTwo, setFacultyNameTwo] = useState('');
  const [facultyNameThree, setFacultyNameThree] = useState('');
  useEffect(async () => {
    const faciltiyAndFacultyData = await getFacultyAndFacilty();

    const AllFacultyObject = Object.values(faciltiyAndFacultyData.Faculty);
    const facilitys = Object.values(faciltiyAndFacultyData);
    const activityData = Object.values(faciltiyAndFacultyData?.Activity);
    const activitySession = activityData.map((e) => {
      return { label: e.label, value: e.value };
    });
    setSessions(activitySession);
    const AllfacultyData = AllFacultyObject.map((fData) => {
      return { label: fData.facultyName, value: fData.id };
    });
    setFacultyOptions(AllfacultyData);

    // all subjects fetch
    const versionData = await getCourseVersion('2023-JAN-GMBA-Term1-Dubai');
    if (versionData.length > 0) {
      setAllSubjects(versionData);
      const versionDataConvert = Object.values(versionData);
      const subjectName = versionDataConvert[0]?.map((data) => {
        return { label: data.courseName, value: data.id };
      });
      // const newSubjectName = [...subjectName, { label: '--', value: '' }];
      setSubjects(subjectName);
    }
  }, []);

  const handleSelectProgramChange = (e, value) => {
    setSessionValue(e.target.value);
  };

  const handleChangedStartDate = (e) => {
    setStartDate(e.target.value);
  };
  const handleChangedEndDated = (e) => {
    setEndDate(e.target.value);
  };
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSelectFacultyChange = (e, value) => {
    setFacultyName(e.target.value);
  };

  const handleSelectFacultyTwoChange = (e, value) => {
    setFacultyNameTwo(e.target.value);
  };

  const handleSelectFacultyThreeChange = (e, value) => {
    setFacultyNameThree(e.target.value);
  };
  const handleToModeChange = (event) => {
    setToMode(event.target.value);
  };
  const onToggleEdit = (id, rowes) => {
    setRows((state) => {
      return rowes.map((row) => {
        if (row.id === id) {
          return { ...row, isEditMode: !row.isEditMode };
        }
        return row;
      });
    });
  };

  const handleInputChange = (e) => {
    console.log('e.target', e.target);
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  const onRevert = (id, rows, index) => {
    const newData = [...rows];
    newData[index].array.map((row) => {
      if (row.id === id) {
        return (row.isEditMode = false);
      }
    });
    setRows(newData);
    setDisableAddActivity(false);
  };

  const handleSelectChangeSubject = (event) => {
    dataStream.activity = event.target.value;
    setSelectValueSubject(event.target.value);
  };
  const handleChangedCredit = (event) => {
    dataStream.durationInWeeks = event.target.value;
  };
  const handleChangedDate = (event) => {
    dataStream.startDate = event.target.value;
  };
  const handleChangedEndDate = (event) => {
    dataStream.endDate = event.target.value;
  };
  const dateFormatter = (date) => {
    let dArr = date.split('-');
    return dArr[2] + '/' + dArr[1] + '/' + dArr[0];
  };
  const handlePopoverOpen = (event) => {
    setAnchorEls(event.currentTarget);
  };

  const handleSelectSubjectChange = (e) => {
    console.log('handleSelectSubjectChange');
    setSelectSubjectValue(e.target.value);
    const subjectData = Object.values(allSubjects);
    const sectionData = subjectData[0]?.filter(
      (ele) => ele.id == e.target.value
    );
    const sectionDropdown =
      subjectData &&
      subjectData.length > 0 &&
      sectionData[0]?.courseOffering?.map((dataEle) => {
        return { label: dataEle.courseSectionId, value: dataEle.id };
      });
    setSections(sectionDropdown);
  };
  const [rows, setRows] = useState([]);
  const [rowSecond, setRowSecond] = useState([]);

  const onToggleEditMode = (check, id, index) => {
    const newData = [...rows];
    newData[index]?.array.forEach((row) => {
      if (row.id === id) {
        row.isEditMode = true;
        if (check === 'done') {
          setLoading(true);
          const payload = {
            AcademicPlannerActivity: {
              termName: newData[index].courseName,
              academicPlannerActivityId: row.id,
              // activityDuration: row.durationInWeeks,
              academicPlannerActivityName: row.activity,
              activityStartDate: dateFormatter(row.startDate),
              activityEndDate: dateFormatter(row.endDate),
            },
          };
          postAcademicPlanner(payload)
            .then((res) => {
              setLoading(false);
              alert(res.message);
              row.isEditMode = false;
              setRows(newData);
              setDisableAddActivity(false);
              console.log('newDat', newData);
            })
            .catch((err) => {
              alert('Failed to add. Please try again.');
              setLoading(false);
              row.isEditMode = false;
              setRows(newData);
              console.log('newDat', newData);
              setDisableAddActivity(false);
            });
        } else if (check === 'edit') {
          setDisableAddActivity(true);
          row.isEditMode = true;
          setRows(newData);
        }
      }
    });
    setEditIndex(index);
  };

  const onChange = (e, row) => {
    if (!previous[row.id]) {
      setPrevious((state) => ({ ...state, [row.id]: row }));
    }
    const value = e.target.value;
    const name = e.target.name;
    const { id } = row;
    const newData = [...rows];
    newData[editIndex]?.array.forEach((row) => {
      if (row.id === id) {
        row[name] = value;
      }
    });
    setRows(newData);
  };
  const handleRefereceCreate = (check, id, index) => {
    console.log('rows================', rows);
    setConfirmDialogAddReference(true);
    let termName = id[index].courseName;
    console.log('termName-----------', termName);
  };

  const handleSubject = (check, id, index) => {
    setDisableAddActivity(true);
    if (check == 'save') {
      setLoading(true);
      let savedData = dataStream;
      let termName = id[index].courseName;
      const payload = {
        AcademicPlannerActivity: {
          termName: termName,
          academicPlannerActivityId: null,
          // activityDuration: savedData.durationInWeeks,
          academicPlannerActivityName: savedData.activity,
          activityStartDate: dateFormatter(savedData.startDate),
          activityEndDate: dateFormatter(savedData.endDate),
        },
      };
      postAcademicPlanner(payload)
        .then((res) => {
          console.log('res', res);
          id[index].array.forEach((item) => {
            item.isEditMode = false;
          });
          setNewActivity(!newActivity);
          setLoading(false);
          setDisableAddActivity(false);
        })
        .catch((err) => {
          setLoading(false);
          alert('Failed to add. Please try again.');
          setDisableAddActivity(false);
        });
    } else {
      const newData = [...rows];
      newData[index]?.array.push(
        createData(
          `rows${rows[index]?.array.length}`,
          <p>{weekNo}</p>,
          <KenSelectWrap
            label="Activity"
            options={selectOptionsSubject}
            value={dataStream.activity}
            dropdownColor="#FFFFFF"
            onChange={handleSelectChangeSubject}
            required
          />,
          <KenInputField
            label="Duration"
            value={dataStream.durationInWeeks}
            dropdownColor="#FFFFFF"
            onChange={handleChangedCredit}
            required
          />,
          <KenDateTimePicker
            name={'startDate'}
            label="Start Date"
            value={dataStream.startDate}
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => handleChangedDate(e)}
          />,
          <KenDateTimePicker
            name={'endDate'}
            label="End Date"
            value={dataStream.endDate}
            type="date"
            required={true}
            // defaultValue={startData}
            onChange={(e) => handleChangedEndDate(e)}
          />,
          true
        )
      );
      setRows(newData);
    }
  };

  const handlePopoverClose = () => {
    setAnchorEls(null);
  };

  React.useEffect(() => {
    setLoading(true);
    let locationData = history?.location?.state?.batchName;
    setLocationData(locationData);
    getAcademicFilter()
      .then((res) => {
        let courseOptions = [];
        let campusOptions = [];
        Object.entries(res['Academic Program']).map(([item, keyVal]) => {
          courseOptions.push({
            label: item,
            value: item,
            id: keyVal.id,
            terms: JSON.parse(keyVal.terms),
          });
        });
        Object.entries(res['Campus']).map(([item, keyVal]) => {
          campusOptions.push({ label: item, value: item });
        });
        setCourseOptions(courseOptions);
        setCampusOptions(campusOptions);
        if (locationData != undefined) {
          setProgramName(locationData);
          let e = { target: { name: 'program', value: locationData } };
          handleFilter(e, courseOptions);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  React.useEffect(() => {
    setLoading(true);
    let data;
    term != undefined
      ? (data = `?programName=${programName}&termName=${term}`)
      : intake != undefined && year != undefined
      ? (data = `?programName=${programName}&intake=${intake}&year=${year}`)
      : year != undefined
      ? (data = `?programName=${programName}&year=${year}`)
      : intake != undefined
      ? (data = `?programName=${programName}&intake=${intake}`)
      : (data = `?programName=${programName}`);
    if (programName != undefined && intake != undefined && year != undefined) {
      setNextApproved(false);
      setDisableMaster(false);
    }
    getAcademicPlannerData(data)
      .then((res) => {
        let responseData = res?.message;
        if (responseData === 'No Data Found') {
          setRows([]);
        } else {
          console.log('resssssssssssssssssssssssssss', res);
          let key = Object.keys(res);
          let values = Object.values(res);
          let alteredData = key.map((el, ind) => {
            return {
              courseName: el,
              array: [...values[ind]],
              termStart: '',
              termEnd: '',
            };
          });
          console.log(alteredData, 'alteredData');
          setRows(alteredData);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [programName, term, intake, year, newActivity, masterImportSuccess]);

  const opens = Boolean(anchorEls);
  const ids = opens ? 'simple-popover' : undefined;
  const manageStartDate = (e) => {
    setStartDate(e.target.value);
  };
  const manageEndDate = (e) => {
    setEndDate(e.target.value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleSelectChange = (e) => {
    setSelectValue(e.target.value);
  };
  const handleSelectOptionChange = (e) => {
    setSelectSectionValue(e.target.value);
  };

  const handleFilter = (e, data) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
    if (e.target.name === 'program') {
      setProgramName(value);
      let newData = data.filter((element) => {
        return element.label === e.target.value;
      });
      let termData = [];
      newData[0]?.terms.map((item) => {
        termData.push({ label: item.name, value: item.name });
      });
      termData.push({ label: 'All', value: 'All' });
      setSelectedAcademicProgram(newData);
      setProgramID(newData[0]?.id);
      setTermDropdown(termData);
      setTerm(undefined);
    } else if (e.target.name === 'intake') {
      setIntake(value);
    }
  };

  function handleIgnoreHolidayDialog() {
    setIgnoreHoliday((prevState) => !prevState);
  }
  function handleFilterProgramDialog() {
    setFilterProgram((prevState) => !prevState);
  }

  const handleCancel = (row, rows, index) => {
    setDisableAddActivity(false);
    const newData = [...rows];
    newData[index].array.pop((item) => item.id === row);
    setRows(newData);
  };
  function handleCloneDialog() {
    setCloneDialog((prevState) => !prevState);
  }

  const masterImportDialog = () => {
    setMasterDialog(true);
    setLoading(false);
    if (!masterDialog) {
      setLoading(true);
      let querry = `?academicProgramId=${selectedAcademicProgram[0]?.id}`;
      getMasterActivityWithTermData(querry)
        .then((res) => {
          console.log(res);
          let responseData = res?.message;
          if (responseData === 'No Data Found') {
            setMasterData([]);
          } else {
            let key = Object.keys(res);
            let values = Object.values(res);
            let alteredData = key.map((el, ind) => {
              return {
                courseName: el,
                array: [...values[ind]],
              };
            });
            console.log(alteredData, 'alteredData');
            setMasterData(alteredData);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };
  const masterImportCancel = () => {
    setMasterData([]);
    setMasterDialog(false);
  };
  const masterImportSubmit = () => {
    setLoading(true);
    const data = `?academicProgramId=${selectedAcademicProgram[0]?.id}&intake=${intake}&year=${year}`;
    getImportTermActivity(data)
      .then((res) => {
        alert(res.message);
        setLoading(false);
        setMasterImportSuccess(!masterImportSuccess);
        setMasterDialog(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const termStartDate = (e, item, index) => {
    const rowsData = [...rows];
    setRows((state) => {
      return rowsData.map((row) => {
        if (row.courseName === item.courseName) {
          return { ...row, termStart: e.target.value };
        }
        return row;
      });
    });
  };
  const termEndDate = (e, item, index) => {
    const rowsData = [...rows];
    setRows((state) => {
      return rowsData.map((row) => {
        if (row.courseName === item.courseName) {
          return { ...row, termEnd: e.target.value };
        }
        return row;
      });
    });
  };
  return (
    <Box>
      {loading && <KenLoader />}
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      <AppBar position="static" elevation={0} className={classes.header}>
        <Toolbar>
          <Typography variant="h6" className={classes.title}>
            Term Academic Planner
          </Typography>
        </Toolbar>
      </AppBar>
      {/* FILTERS */}
      <Box mt={2} mb={2} className={classes.sortingSection}>
        <KenSelect
          name="program"
          label="Academic Program *"
          options={courseOptions}
          value={programName}
          dropdownColor="#ffffff"
          onChange={(el) => handleFilter(el, courseOptions)}
          required={true}
        />
        <KenSelect
          label="Year *"
          options={yearOptions}
          value={year}
          dropdownColor="#ffffff"
          onChange={(e) => setYear(e.target.value)}
          required={true}
        />
        <KenSelectWrap
          name="intake"
          label="Intake *"
          options={intakeOptions}
          value={intake}
          dropdownColor="#FFFFFF"
          onChange={(el) => handleFilter(el, intakeOptions)}
          required
        />
      </Box>
      <Box mt={2} mb={2} className={classes.mainActions}>
        <Button
          className={classes.filterButton}
          variant="contained"
          color="primary"
          onClick={masterImportDialog}
          disabled={disableMaster}
        >
          Master Term Import
        </Button>
        <Button
          className={classes.filterButton}
          variant="contained"
          color="primary"
          onClick={handleCloneDialog}
        >
          Clone
        </Button>
        {/* <Button
          // className={classes.filterButton}
          startIcon={<RiFilterLine />}
          variant="contained"
          color="primary"
          onClick={handleFilterProgramDialog}
        >
          Filter
        </Button> */}
      </Box>
      {/* TERM DATA */}
      {rows.length > 0 ? (
        rows.map((elem, index) => {
          return (
            <Box className="cardlsitbox" style={{ marginBottom: '20px' }}>
              <Accordion expanded={accordienCheck}>
                <AccordionSummary expandIcon={accordienCheck}>
                  {accordienCheck ? (
                    <AiOutlineMinusSquare
                      size={20}
                      style={{ marginTop: '10px' }}
                      onClick={() => setAccordienCheck(!accordienCheck)}
                    />
                  ) : (
                    <AiOutlinePlusSquare
                      size={20}
                      style={{ marginTop: '10px' }}
                      onClick={() => setAccordienCheck(!accordienCheck)}
                    />
                  )}{' '}
                  &nbsp;{' '}
                  <Grid item xs={5} style={{ marginTop: '10px' }}>
                    <span style={{ color: '#092682', font: 'Open Sans' }}>
                      {/* {elem.courseName} */}
                      Term {index}
                    </span>
                  </Grid>
                  <Grid container xs={7}>
                    <Grid container xs={6}>
                      <p className={classes.dateLabels}>Term Start Date</p>
                      <KenDateTimePicker
                        // label={'Start date'}
                        value={elem.termStart}
                        type="date"
                        required={true}
                        onChange={(e) => {
                          termStartDate(e, elem, index);
                        }}
                        style={{ width: '160px' }}
                      />
                    </Grid>
                    <Grid container xs={6}>
                      <p className={classes.dateLabels}>Term End Date</p>
                      <KenDateTimePicker
                        // label={'End date'}
                        value={elem.termEnd}
                        type="date"
                        defaultValue={termEnd}
                        onChange={(e) => {
                          termEndDate(e, elem, index);
                        }}
                        style={{ width: '160px' }}
                      />
                    </Grid>
                  </Grid>
                </AccordionSummary>
                <AccordionDetails>
                  {/* <KenCard elevation={0}> */}
                  <TableContainer component={Paper}>
                    <div style={{ marginLeft: '15px' }}>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        style={{
                          // marginLeft: '1255px'
                          float: 'right',
                          textAlign: 'end',
                          marginBottom: '15px',
                        }}
                        // onClick={() => handleSubject('add', rows, index)}
                        onClick={() => handleRefereceCreate('add', rows, index)}
                        disabled={disableAddActivity}
                      >
                        Add Activity
                      </Button>
                    </div>
                    <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                      <TableHead>
                        <TableRow>
                          <TableCell align="left">Week No.</TableCell>
                          <TableCell align="left">Activity</TableCell>
                          <TableCell align="left">Subject</TableCell>
                          <TableCell align="left">Faculty</TableCell>
                          <TableCell align="left">Start Date</TableCell>
                          <TableCell align="left">End Date</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {elem?.array?.length > 0 ? (
                          elem?.array.map((row) => {
                            return (
                              <TableRow key={row.id}>
                                <KenGridEditable
                                  {...{
                                    row,
                                    onChange,
                                    columns: [
                                      {
                                        column_name: 'durationInWeeks',
                                        is_inline_edit: false,
                                        inline_edit_type: '',
                                        label: 'Week No.',
                                      },
                                      {
                                        column_name: 'activity',
                                        is_inline_edit: false,
                                        inline_edit_type: 'kenSelect',
                                        dropdown: selectOptionsSubject,
                                        label: 'Activity',
                                      },
                                      {
                                        column_name: 'subject',
                                        is_inline_edit: false,
                                        inline_edit_type: 'kenInput',
                                        label: 'Subject',
                                      },
                                      {
                                        column_name: 'faculty',
                                        is_inline_edit: false,
                                        inline_edit_type: '',
                                        label: 'Faculty',
                                      },
                                      {
                                        column_name: 'startDate',
                                        is_inline_edit: false,
                                        inline_edit_type: 'kenDatePicker',
                                        label: 'Start Date',
                                      },
                                      {
                                        column_name: 'endDate',
                                        is_inline_edit: false,
                                        inline_edit_type: 'kenDatePicker',
                                        label: 'End Date',
                                      },
                                    ],
                                  }}
                                />
                                <TableCell
                                  className={classes.selectTableCell}
                                  style={{ textAlign: 'center' }}
                                >
                                  {row.isEditMode ? (
                                    <>
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() =>
                                          onToggleEditMode(
                                            'done',
                                            row.id,
                                            index
                                          )
                                        }
                                      >
                                        Save
                                      </Button>
                                      <IconButton
                                        aria-label="revert"
                                        onClick={() =>
                                          onRevert(row.id, rows, index)
                                        }
                                      >
                                        <RevertIcon />
                                      </IconButton>
                                    </>
                                  ) : (
                                    <>
                                      {!row.saved && (
                                        <IconButton
                                          aria-label="edit"
                                          onClick={() =>
                                            onToggleEditMode(
                                              'edit',
                                              row.id,
                                              index
                                            )
                                          }
                                        >
                                          <EditIcon />
                                        </IconButton>
                                      )}
                                      {row.saved && (
                                        <>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() =>
                                              handleSubject('save', rows, index)
                                            }
                                          >
                                            Save
                                          </Button>
                                          <IconButton
                                            aria-label="revert"
                                            onClick={() =>
                                              handleCancel(row.id, rows, index)
                                            }
                                          >
                                            <RevertIcon />
                                          </IconButton>
                                        </>
                                      )}
                                    </>
                                  )}
                                </TableCell>
                              </TableRow>
                            );
                          })
                        ) : (
                          <TableRow>
                            {' '}
                            <TableCell
                              className={classes.noDataFound}
                              colSpan={6}
                              align="center"
                            >
                              No Data
                            </TableCell>{' '}
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {/* </KenCard> */}
                </AccordionDetails>{' '}
              </Accordion>
            </Box>
          );
        })
      ) : (
        <Box className="cardlsitbox">
          <Accordion expanded={accordienCheck}>
            <AccordionSummary expandIcon={accordienCheck}>
              {accordienCheck ? (
                <AiOutlineMinusSquare
                  size={20}
                  onClick={() => setAccordienCheck(!accordienCheck)}
                />
              ) : (
                <AiOutlinePlusSquare
                  size={20}
                  onClick={() => setAccordienCheck(!accordienCheck)}
                />
              )}{' '}
              &nbsp;{' '}
              <span style={{ color: '#092682', font: 'Open Sans' }}>
                Term 1
              </span>
            </AccordionSummary>
            <AccordionDetails>
              <KenCard elevation={0}>
                <TableContainer component={Paper}>
                  <Table sx={{ minWidth: 700 }} aria-label="spanning table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">Week No.</TableCell>
                        <TableCell align="left">Activity</TableCell>
                        <TableCell align="left">Subject</TableCell>
                        <TableCell align="left">Faculty</TableCell>
                        <TableCell align="left">Start Date</TableCell>
                        <TableCell align="left">End Date</TableCell>
                        <TableCell align="center">Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        {' '}
                        <TableCell
                          className={classes.noDataFound}
                          colSpan={6}
                          align="center"
                        >
                          No Data
                        </TableCell>{' '}
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </KenCard>
            </AccordionDetails>{' '}
          </Accordion>
        </Box>
      )}
      {/* Next Button */}
      <div className="activityNextButton">
        <Button
          size="small"
          variant="contained"
          color="primary"
          onClick={() => {
            history.push({
              pathname: `${routes.fullCalendar}`,
              state: {
                programName: programName,
                intake: intake,
                year: year,
                batchName: locationData,
                id: programID,
              },
            });
            sessionStorage.setItem('programName', programName);
            sessionStorage.setItem('intake', intake);
            sessionStorage.setItem('year', year);
          }}
          disabled={nextApproved}
        >
          Next
        </Button>
      </div>

      {/* Filter Button */}
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            FILTER
          </Typography>
        }
        open={filterProgram}
        icon={<RiCheckFill />}
        handleClose={() => handleFilterProgramDialog()}
        negativeButtonClick={() => handleFilterProgramDialog()}
        positiveButtonClick={() => handleFilterProgramDialog()}
        positiveButtonText="Submit"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <KenSelectWrap
              label="Semester"
              options={selectOptions}
              value={selectValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectChange}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label={'Start date'}
              value={startDate}
              type="date"
              required={true}
              defaultValue={startDate}
              onChange={manageStartDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenDateTimePicker
              label={'End date'}
              value={endDate}
              type="date"
              required={true}
              defaultValue={endDate}
              onChange={manageEndDate}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Select City"
              name="city"
              options={campusOptions}
              value={filters?.city}
              dropdownColor="#FFFFFF"
              onChange={handleFilter}
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <KenSelectWrap
              label="Total Section"
              options={selectOptionsSection}
              value={selectSectionValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectOptionChange}
              required
            />
          </Grid>
        </Grid>
      </KenDialog>
      {/* Program Clone */}
      <KenDialog
        title={
          <>
            <Typography variant="h6" className={classes.dialogHeader}>
              Program Clone
            </Typography>
            {/* <CloseIcon /> */}
          </>
        }
        open={cloneDialog}
        icon={<RiCheckFill />}
        handleClose={() => handleCloneDialog()}
        negativeButtonClick={() => handleCloneDialog()}
        positiveButtonClick={() => handleCloneDialog()}
        positiveButtonText="Clone"
        negativeButtonText="Cancel"
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <span>From</span>

            <Grid item xs={12}>
              <KenSelectWrap
                name="programFrom"
                label="Program"
                options={courseOptions}
                value={formValues.programFrom}
                dropdownColor="#FFFFFF"
                onChange={(e) => handleInputChange(e)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <KenSelectWrap
                name="intakeFrom"
                label="Intake"
                options={intakeOptions}
                value={formValues.intakeFrom}
                dropdownColor="#FFFFFF"
                onChange={(e) => handleInputChange(e)}
                required
              />
            </Grid>
            <Grid item xs={12}>
              <KenSelectWrap
                name="courseFrom"
                label="Batch"
                options={courses}
                value={formValues.courseFrom}
                dropdownColor="#FFFFFF"
                onChange={(e) => handleInputChange(e)}
                required
              />
            </Grid>
          </Grid>
        </Grid>
      </KenDialog>
      {/* Master Term Import */}
      <KenDialog
        title={
          <>
            <Typography variant="h6" className={classes.dialogHeader}>
              Master Term Import
            </Typography>
          </>
        }
        open={masterDialog}
        icon={<RiCheckFill />}
        handleClose={() => masterImportCancel()}
        negativeButtonClick={() => masterImportCancel()}
        positiveButtonClick={() => masterImportSubmit()}
        positiveButtonText="Import"
        negativeButtonText="Cancel"
        style={{ width: '80%' }}
        dividers
      >
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {masterData.length > 0 ? (
              masterData.map((elem, index) => {
                return (
                  <Accordion expanded={masterAccordian}>
                    <AccordionSummary expandIcon={masterAccordian}>
                      {masterAccordian ? (
                        <AiOutlineMinusSquare
                          size={20}
                          onClick={() => setMasterAccordian(!masterAccordian)}
                        />
                      ) : (
                        <AiOutlinePlusSquare
                          size={20}
                          onClick={() => setMasterAccordian(!masterAccordian)}
                        />
                      )}{' '}
                      &nbsp;{' '}
                      <span style={{ color: '#092682', font: 'Open Sans' }}>
                        {elem.courseName}
                      </span>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid item xs={12}>
                        <KenGrid
                          columns={masterHead}
                          data={elem?.array}
                          pagination={{ disabled: true }}
                          toolbarDisabled={true}
                        />
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                );
              })
            ) : (
              <Accordion expanded={masterAccordian}>
                <AccordionSummary expandIcon={masterAccordian}>
                  {masterAccordian ? (
                    <AiOutlineMinusSquare
                      size={20}
                      onClick={() => setMasterAccordian(!masterAccordian)}
                    />
                  ) : (
                    <AiOutlinePlusSquare
                      size={20}
                      onClick={() => setMasterAccordian(!masterAccordian)}
                    />
                  )}{' '}
                  &nbsp;{' '}
                  <span style={{ color: '#092682', font: 'Open Sans' }}>
                    Term 1
                  </span>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid item xs={12}>
                    <KenGrid
                      columns={masterHead}
                      data={[]}
                      pagination={{ disabled: true }}
                      toolbarDisabled={true}
                    />
                  </Grid>
                </AccordionDetails>
              </Accordion>
            )}
          </Grid>
        </Grid>
      </KenDialog>
      <Reference
        title={'Add Reference'}
        // children={}
        isOpen={confirmDialogAddReference}
        handleClose={() => setConfirmDialogAddReference(false)}
        // handleEvent={handleAddEventRefernce}
        positiveBtn={'Add'}
        negativeBtn={'Cancel'}
        handleSelectSubjectChange={handleSelectSubjectChange}
        sessions={sessions}
        id={null}
        subjects={subjects}
        facultyOptions={facultyOptions}
        selectSubjectValue={selectSubjectValue}
      />
      {/* <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            {<b>Add Reference</b>}
          </Typography>
        }
        open={confirmDialogAddReference}
        // icon={<RiCheckFill />}
        handleClose={() => setConfirmDialogAddReference(false)}
        negativeButtonClick={
          // setConfirm(false);
          // if (revertDropEvent.current) revertDropEvent.current();
          (e) => setConfirmDialogAddReference(false)
          // (e) => setConfirmDialogAdd(false)
        }
        positiveButtonClick={(e) => handleAddEventRefernce(e)}
        positiveButtonText={'Create'}
        negativeButtonText={'Cancel'}
        dividers
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <KenSelectWrap
              // disabled={readOnly}
              label="Type of Activity"
              options={sessions}
              value={sessionValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectProgramChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'startDate'}
              label="Start Date"
              // disabled={readOnly}
              value={startDate}
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={(e) => handleChangedStartDate(e)}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'endDate'}
              label="End Date"
              // disabled={readOnly}
              value={endDate}
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={(e) => handleChangedEndDated(e)}
            />
          </Grid>
          {/* <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'endTime'}
              label="End Time"
              value={endTime}
              type="time"
              required={true}
              // defaultValue={startData}
              onChange={(e) => handleChangedEndTime(e)}
            />
          </Grid> */}
      {/* <Grid item xs={12} md={12}>
            <Checkbox
              checked={recurrent}
              onChange={handleChangeRecurrent}
              color="secondary"
            />
            Recurrent Session
          </Grid> */}
      {/* 
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Subject"
              options={subjects}
              // disabled={readOnly}
              value={selectSubjectValue}
              dropdownColor="#FFFFFF"
              onChange={(e) => handleSelectSubjectChange(e)}
              // styles={CustomStyle}
              required
            />
          </Grid> */}
      {/* <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Section"
              options={sections}
              value={selectSectionValue}
              dropdownColor="#FFFFFF"
              onChange={(e) => handleSelectSectionChange(e)}
              // styles={CustomStyle}
              required
            />
          </Grid> */}
      {/* <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Faculty1"
              options={facultyOptions}
              value={facultyName}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacultyChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Faculty2"
              options={facultyOptions}
              value={facultyNameTwo}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacultyTwoChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Faculty3"
              options={facultyOptions}
              value={facultyNameThree}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacultyThreeChange}
              // styles={CustomStyle}
              required
            />
          </Grid> */}
      {/* <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Facility"
              options={faciltyOptions}
              value={facilityName}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacilityChange}
              // styles={CustomStyle}
              required
            />
          </Grid> */}
      {/* </Grid>
      </KenDialog>  */}
    </Box>
  );
};

export default AddActivity;
